
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from "react-toastify";
import { OrderAPI } from '../../helpers/firebase_helper';
const keyId = process.env.REACT_APP_RAZORPAY_KEY_ID;

const RenderRazorpay = ({ onCancel, cognito_id, orderDetails, currency, plan_name, billing_frequency, onPaymentSuccess, userDetails }) => {
 
  const [isVerifying, setIsVerifying] = useState(false);

  useEffect(() => {

    const loadRazorpayScript = () => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };


    loadRazorpayScript()
      .then(() => {
        const options = {
          key: keyId,
         
          order_id: orderDetails.order_id,
          customer_id: orderDetails.customer_id,
    
          handler: function (response) {
          // console.log("response", response)
            setIsVerifying(true);


            const verificationPayload = {
              cognito_id: cognito_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              billing_plan: plan_name,
              billing_frequency: billing_frequency,
            };
           
          //  console.log("verificationPayload",verificationPayload)
            OrderAPI.paymentVerify(verificationPayload)
              .then((verificationResponse) => {
                toast.success("Verification successful!");

                if (window.Razorpay && window.Razorpay.activeInstance) {
                  window.Razorpay.activeInstance.close();
                }
                onPaymentSuccess(verificationResponse);
                setIsVerifying(false);
              })
              .catch((error) => {
                console.error("Verification failed:", error.response || error);
                setIsVerifying(false);

              });
          },
          prefill: {
            name: `${userDetails.firstname} ${userDetails.lastname}`,
            email: userDetails.email, 
            contact: userDetails.phone_number,
          },
          theme: {
            color: "#3399cc",
          },
          modal: {
            ondismiss: function () {
              // console.log("Checkout form closed.");
              toast.info('You did not completed the payment process so you have not subscribed to plan. ');
              onCancel();

            },
          },
        };


        const rzp1 = new window.Razorpay(options);


        rzp1.open();
      })
      .catch(() => {
        console.error("Failed to load Razorpay script.");
      });
  }, [cognito_id, orderDetails, currency, onPaymentSuccess]);

  return (
    <>
      {isVerifying && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-75"
          style={{ zIndex: 1050 }}
        >
          <div className="text-center text-white">
            <div className="spinner-border text-light mb-3" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p>Verifying Payment...</p>
          </div>
        </div>
      )}
    </>
  );

};

export default RenderRazorpay;


